import { render, staticRenderFns } from "./ShoppingOverview.vue?vue&type=template&id=7e5b7f34&scoped=true&"
import script from "./ShoppingOverview.vue?vue&type=script&lang=js&"
export * from "./ShoppingOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5b7f34",
  null
  
)

export default component.exports